import {put, takeEvery, select} from 'redux-saga/effects';
import {toast} from 'react-toastify';
import {updateOrderRefund} from 'helpers/services/api/ordersV2';
import {
  MAKE_REFUND,
  OPEN_CANCELLATION_REFUND_MODAL
} from 'store/global/ordersV2/CancellationRefund/action';
import {GET_ORDER} from 'store/ordersV2/orderDetails/action';

export function* makeCancellationRefund({payload: {data, invoiceId, orderId}}) {
  try {
    const locationId = yield select((state) => state.user.locationId);

    const refund = yield updateOrderRefund(orderId, {...data, locationId});

    if (refund) {
      yield put(
        OPEN_CANCELLATION_REFUND_MODAL({
          isOpenModal: false,
          invoiceId: null,
          showCannotDeliveryText: false,
          loadingRefund: false,
          errorText: null
        })
      );
      if (orderId) {
        yield put(GET_ORDER(orderId));
      }
      toast.success(
        'The customer was refunded and a confirmation email was sent'
      );
    }
  } catch (error) {
    yield put(
      OPEN_CANCELLATION_REFUND_MODAL({
        isOpenModal: false,
        invoiceId: null,
        showCannotDeliveryText: false,
        loadingRefund: false,
        errorText: null
      })
    );
    console.log('SAGA ERROR', error);
  }
}

function* cancellationRefundV2Saga() {
  yield takeEvery(MAKE_REFUND, makeCancellationRefund);
}

export default cancellationRefundV2Saga;
